document.addEventListener('DOMContentLoaded', async () => {

  const containers = document.querySelectorAll('.watch-variants');

  for (const container of containers) {

    const productType = container.dataset.productType;
    const currentProductId = container.dataset.productId;

    try {

      const response = await fetch(
        `/search?q=${encodeURIComponent('product_type:"' + productType + '"')}&type=product&view=variant-json`
      );

      const data = await response.json();

	  const currentProduct = data.products.find(
		item => Number(item.id) === Number(currentProductId)
	  );

		const otherProducts = data.products.filter(
		item => Number(item.id) !== Number(currentProductId)
		);

		data.products = currentProduct
		? [currentProduct, ...otherProducts]
		: otherProducts;

      if (!data.products || data.products.length <= 1) {
        continue;
      }

      let html = '<div class="variant-products-row">';

      data.products.slice(0, 4).forEach(item => {

        const activeClass =
          Number(item.id) === Number(currentProductId)
            ? 'active'
            : '';

        html += `
          <a
            href="${item.url}"
            class="variant-product-item ${activeClass}"
          >
            <img
              src="${item.image}"
              alt="${item.title}"
              width="80"
              height="80"
              loading="lazy"
            >
          </a>
        `;
      });

      const remaining = data.products.length - 4;

      if (remaining > 0) {
        html += `
          <span class="variant-product-more">
            +${remaining}
          </span>
        `;
      }

      html += '</div>';

      container.innerHTML = html;

    } catch (error) {
      console.error(error);
    }
  }
});